import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import LoadingBar from './ui/LoadingBar';
import MapView from './MapView';

import config from './../config';
import helpers from './../lib/helpers';

function LocationsMap(props) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);

	const history = useHistory();

	useEffect(() => {
		if (!data) {
			fetchData();
		}
	});

	useEffect(() => {
		fetchData();
	}, [props.searchParams, props.parentId])

	const fetchData = () => {
		setLoading(true);
		setData(null);

		let urlParams = [];

		if (props.searchParams != '') {
			let searchParams = helpers.parseSearchParams(props.searchParams);

			if (searchParams.nafn) {
				urlParams.push('name='+searchParams.nafn);
			}

			if (searchParams.parent) {
				urlParams.push('parent='+searchParams.parent);
			}

			if (searchParams.tegund) {
				urlParams.push('type='+searchParams.tegund)
			}

			if (searchParams.tilheyrir) {
				urlParams.push('parent='+searchParams.tilheyrir)
			}
		}

		if (props.parentId) {
			urlParams.push('parent='+props.parentId);
		}

		urlParams.push('has_location=True');
		urlParams.push('simple=True');
		urlParams.push('limit=8000');

		fetch(config.apiRoot+'/api/locations/?'+urlParams.join('&'))
			.then((result) => result.json())
			.then((json) => {
				setData(json.results.map((item) => {
					return {
						id: item.id,
						label: item.name,
						latLng: [item.lat, item.lng]
					}
				}));
				setLoading(false);

				if (props.onResponse) {
					props.onResponse(json.results);
				}
			});
	}

	return (
		<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
			<MapView mapData={data || []} />
		</div>
	)
}

export default LocationsMap;
